// extracted by mini-css-extract-plugin
module.exports = {"story-elements-page-container":"story-elements_story-elements-page-container__3qtol"};